<script lang="ts">
	import { format } from 'svelte-i18n';
	import { CardGrid, Input, SelectCard } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import NoSearchResults from '../Lists/NoSearchResults.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let filterPrefix: string;
	export let list: {
		id: string;
		name: string;
		image: string;
		deviceType?: string;
		index?: number;
	}[];

	let filterValue = '';
	let selectedCard = list?.[0];
	$: filteredList = list.filter(
		(i) => filterValue === '' || (new RegExp(`${filterValue}`, 'i').test(i.name) && i.index > 0),
	);
</script>

<div class="mb-m d-flex justify-content-end">
	<Input
		type="text"
		id="input-device-search"
		aria-labelledby="input-device-search"
		label={capFirstChar($format('search', { default: 'Search' }))}
		icon="fas fa-search"
		class="width-md-l width-sm-full"
		clearButton
		bind:value={filterValue}
		a11yProps={{
			iconButtonAriaLabel: $format('schedules_clear', { default: 'Clear' }),
		}}
	/>
</div>

{#if filteredList?.length > 0}
	<CardGrid lg={290} sm={270} gridGap="s">
		{#each filteredList as card (card.index)}
			<div class="d-flex">
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					class="width-full"
					type="horizontal"
					variant="radio"
					title={card.name}
					descriptiveText={card.deviceType || ''}
					image={card.image}
					titleHighlight={filterValue}
					selected={card.index === selectedCard?.index}
					on:click={() => {
						selectedCard = card;
						filterPrefix = card.id;
					}}
					hideRightSlot
				/>
			</div>
		{/each}
	</CardGrid>
{:else if filterValue}
	<NoSearchResults search={filterValue} />
{/if}
